module.exports = __webpack_public_path__ + "static/media/industrial_contact_us.7f701c62.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/images/industrial_contact_us.png
// module id = 275
// module chunks = 0